<div class="detail-box">
    <ng-container class="detail-item" *ngIf="estemporaneiDetails && estemporaneiDetails.length > 0; else no_estemporanei">
        <table aria-label="quote-table" class="table">
            <thead class="bg-light">
                <tr>
                    <th scope="col">Data effetto</th>
                    <th scope="col">Fondo</th>
                    <th scope="col">Percentuale</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let estemporaneo of estemporaneiDetails">
                    <tr>
                        <td>{{ estemporaneo.effectDate | date }}</td>
                        <td>{{ estemporaneo.fundName }}</td>
                        <td>{{ estemporaneo.percentage }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </ng-container>
    <ng-template #no_estemporanei>
        <h6>Non risultano estemporanei.</h6>
    </ng-template>
</div>
